import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { TopBar } from "@/offer/TopBar";
import { Hero } from "@/offer/Hero";
import { Marquee } from "@/offer/Marquee";
import { Overview } from "@/offer/Overview";
import { Challenges } from "@/offer/Challenges";
import { Modules } from "@/offer/Modules";
import { Roadmap } from "@/offer/Roadmap";
import { Team } from "@/offer/Team";
import { Investment } from "@/offer/Investment";
import { Terms } from "@/offer/Terms";
import { Acceptance } from "@/offer/Acceptance";
import { PrintDocument } from "@/offer/PrintDocument";

function App() {
  useEffect(() => {
    document.title = "Commercial Offer for Vision Field Equipment";
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <div className="grain bg-base text-ink2 print:hidden">
        <TopBar />
        <div id="offer-document">
          <Hero />
          <Marquee />
          <Overview />
          <Challenges />
          <Modules />
          <Roadmap />
          <Team />
          <Investment />
          <Terms />
          <Acceptance />
        </div>
      </div>
      <PrintDocument />
    </>
  );
}

export default App;
